var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('saa',{ref:"saa"}),_c('Video',{on:{"shelly-plug-state-changed":_vm.reloadPower}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }